import { Slider } from '@civilgrid/ui/components';
import type { MapObject } from '~/common/types';
import { useCivilDrawStore } from '../../civilDrawStoreContext';

interface Props {
  currentObject: MapObject;
}

export default function ObjRadius({ currentObject }: Props) {
  const store = useCivilDrawStore();
  if (currentObject.type !== 'circle') {
    return null;
  }

  const r = currentObject.properties.radius;
  const value = Number(r.toFixed(2));

  return (
    <Slider
      className="my-6"
      label="Radius"
      labelClassName="text-base font-bold text-grey-50"
      valueClassName="text-grey-50 min-w-[4em]"
      min={50}
      max={5_000}
      step={5}
      value={value}
      formatValue={(value) => `${value} ft`}
      onValueChange={(value) => {
        store.updateObject({
          properties: {
            radius: value,
          },
        });
        store.shouldRedraw = true;
      }}
      data-testid="civildraw-object-radius-slider"
    />
  );
}
